// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/font/Inter-VariableFont.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Inter";
  src: local("Inter"), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}
* {
  font-family: "Inter";
  margin: 0;
  padding: 0;
  text-decoration: none;
  list-style: none;
}

.clearfix::after {
  content: "";
  display: table;
  clear: both;
}

html,
body {
  font-size: 16px;
}

body {
  overflow-x: hidden;
}

section {
  width: 100%;
}

.row {
  width: 96%;
  margin: 0 auto;
  display: flex;
  gap: 2%;
}

.col-7 {
  width: 58.33%;
}

.col-5 {
  width: 41.66%;
}

.text {
  color: #000000;
  text-align: center;
  font-size: 22px;
  font-weight: 400;
  line-height: 30px;
}

.subtext {
  color: #000000;
  text-align: center;
  font-size: 10px;
  font-weight: 500;
  opacity: 50%;
}

.blurred {
  filter: blur(10px);
}

.bg-blurred {
  filter: blur(15px);
}

.my-input:focus,
#country_code:focus,
select:focus,
.profile-info-form input:focus,
.profile-info-container select:focus {
  outline: none;
  box-shadow: none;
  border: 1px solid rgba(238, 58, 36, 0.8);
}

.error,
.MuiFormHelperText-root.Mui-error {
  font-size: 11px;
  margin: 0.25rem;
}

.error-bg-white {
  color: rgba(238, 58, 36, 0.8);
  font-size: 0.91vw;
}

.required-field {
  color: rgba(238, 58, 36, 0.8);
  font-weight: 400;
  font-size: 0.902vw;
  line-height: 1.25vw;
  position: relative;
  top: -0.25vw;
}

input,
.profile-info-container select {
  border-radius: 6px;
}

input::placeholder {
  font-size: 12px;
  font-weight: 400;
  line-height: 14.52px;
  color: #363636;
}

select {
  cursor: pointer;
}

select:disabled {
  cursor: default;
}

.stepper .round:not(:last-child) {
  cursor: pointer;
}

@media (max-width: 768px) {
  .col-5 {
    width: 100%;
  }
}
.Mui-focused .MuiOutlinedInput-notchedOutline {
  border-color: #ee3a24 !important;
}

.MuiInputBase-root.MuiInputBase-formControl:hover .MuiOutlinedInput-notchedOutline {
  border-color: #ee3a24 !important;
}

.button {
  font-weight: 600;
  font-size: 14px;
  border-radius: 4px;
  border: 1px solid #EE3A24;
  background-color: transparent;
  color: #EE3A24;
  line-height: 16.94px;
  padding: 5px 24px;
  transition: 0.2s ease-in-out all;
  cursor: pointer;
}

.button:not([disabled]):hover {
  background-color: #EE3A24 !important;
  color: #fff;
}

.button:not([disabled]):active {
  background-color: #923D32;
  border-color: #923D32;
  color: #fff;
}

.button svg {
  background: transparent;
  transition: 0.2s ease-in-out all;
}

.button svg path {
  fill: #EE3A24;
}

.button:hover svg path {
  fill: #fff;
}

button:disabled,
button[disabled] {
  border: 1px solid #808080;
  color: #808080;
  cursor: default;
}

button:disabled {
  cursor: default;
  border: 1px solid #ee3a24;
  color: #ee3a24;
  background-color: #fff;
}

button:disabled svg path {
  fill: #ee3a24 !important;
}

.button2 {
  font-size: 1.040625vw;
  font-weight: 600;
  line-height: 1.665vw;
  letter-spacing: 0em;
  text-align: center;
  border-radius: 0.555vw;
  border: 1px solid #ffffff;
  color: #EE3A24;
  transition: 0.2s ease-in-out all;
  cursor: pointer;
  color: #ffffff;
  background: rgba(255, 255, 255, 0.2);
  height: 3.12243vw;
  min-width: 12.4875vw;
}

.button2:not([disabled]):hover {
  background: #EE3A24;
  color: #fff;
}

.button2:not([disabled]):active {
  background: #ca311e;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.2509803922) inset;
  border: none;
}

.button2 svg {
  background: transparent;
  transition: 0.2s ease-in-out all;
}

.button2 svg path {
  fill: #EE3A24;
}

.button2:hover svg path {
  fill: #fff;
}

.button2:disabled,
.button2[disabled] {
  background: rgba(77, 77, 77, 0.2);
  border: 1px solid rgba(77, 77, 77, 0.2);
  color: rgba(46, 46, 46, 0.6);
  cursor: default;
}

nav .custom-create-title {
  width: 100%;
  flex-basis: 100%;
  font-family: Inter;
  font-size: 1.125rem;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: center;
  color: #ee3a24;
}

.play-icon-button {
  font-weight: 600;
  font-size: 14px;
  border-radius: 4px;
  border: 1px solid #ee3a24;
  background-color: transparent;
  color: #ee3a24;
  line-height: 16.94px;
  transition: 0.2s ease-in-out all;
  cursor: pointer;
  padding: 0px;
  border: none;
}

.play-icon-button svg {
  width: 80%;
}

.play-icon-button:hover svg path {
  stroke: white;
}

.play-icon-button:hover svg {
  fill: #ee3a24;
}

.header {
  width: 100%;
  background-color: #fff;
  z-index: 2;
  position: relative;
  min-height: 3.81618vw;
}

.nav-list li .dropdown-menu > a {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
}

.settings select {
  border: none;
  width: 20px;
}

.dashboard-header {
  position: fixed;
  width: 100%;
  background-color: #fff;
  z-index: 2;
}

.header-absolute {
  position: absolute !important;
  top: 0;
  z-index: 2;
  width: 100%;
  background: rgba(255, 255, 255, 0.55);
}

.header-absolute2 {
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 2;
}

nav {
  max-width: 96%;
  width: 100%;
  margin: 0 auto;
  padding: 0.49vw 0;
}

nav img {
  width: 80%;
}

ul {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header nav ul li {
  position: relative;
  top: 0.42vw;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.user-image {
  display: flex;
}

.nav-list {
  display: flex;
}

.nav-list {
  list-style: none;
}

.nav-list li:nth-child(1) {
  margin-right: 1.65vw;
}

.nav-list li {
  position: relative;
}

.nav-list li a {
  display: block;
  text-decoration: none;
  color: black;
}

.user-image img {
  width: 2.775vw;
  height: 2.775vw;
  border-radius: 0.20868vw;
  box-shadow: 0 0 0.20868vw gainsboro;
  margin: 0.2775vw;
}

.user-image .sb-avatar,
.user-image .sb-avatar__text {
  width: 2.15118vw !important;
  height: 2.15118vw !important;
}

.dropdown {
  width: 100%;
  position: absolute;
  z-index: 999;
  display: none;
}

.dropdown-menu {
  margin: 0.4vw 0.25vw;
}

.show {
  width: 16.65vw;
  height: auto;
  padding: 1.39vw 1.11vw;
  background-color: #fff;
  box-shadow: 0 0 3px gainsboro;
  border-radius: 3px;
  position: absolute;
  top: 3.01vw;
  right: -1.11vw;
  z-index: 999;
  display: block;
}

.show li {
  padding: 0.555vw 0.8325vw;
}

.user-email {
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  display: block;
  color: #ababab;
  text-overflow: ellipsis;
}

.dropdown li {
  display: block;
}

.flex-list-item {
  display: flex;
  gap: 25px;
  align-items: center;
}

/* Loader */
.mesh-loader {
  position: fixed;
  background-color: rgba(0, 0, 0, 0.2);
  height: 100vh;
  width: 100vw;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999999;
}

.mesh-loader .circle {
  width: 25px;
  height: 25px;
  position: fixed;
  background: #2962ff;
  border-radius: 50%;
  margin: -12.5px;
  animation: mesh 3s ease-in-out infinite -1.5s;
}

.mesh-loader > div .circle:last-child {
  animation-delay: 0s;
}

.mesh-loader > div {
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 99999999999;
}

.mesh-loader > div:last-child {
  transform: rotate(90deg);
}

.blurred-background {
  filter: blur(10px);
}

/* Loader */
.theme-backdrop:after {
  background: #EE3A24;
  filter: blur(154.1499938965px);
  top: -25.69px;
  left: -51px;
  z-index: -1;
}

.theme-backdrop:before {
  background: #9747ff;
  filter: blur(154.1499938965px);
  bottom: 0px;
  right: -51px;
}

@keyframes mesh {
  0% {
    transform-origin: 50% -100%;
    transform: rotate(0);
  }
  50% {
    transform-origin: 50% -100%;
    transform: rotate(360deg);
  }
  50.00001% {
    transform-origin: 50% 200%;
    transform: rotate(0deg);
  }
  100% {
    transform-origin: 50% 200%;
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/style/_fonts.scss","webpack://./src/style/App.scss","webpack://./src/style/_colors.scss","webpack://./src/style/_variables.scss"],"names":[],"mappings":"AAAA;EACI,oBAAA;EACA,+EAAA;ACCJ;AADA;EDII,oBAAA;ECFF,SAAA;EACA,UAAA;EACA,qBAAA;EACA,gBAAA;AAGF;;AADA;EACE,WAAA;EACA,cAAA;EACA,WAAA;AAIF;;AAFA;;EAEE,eAAA;AAKF;;AAHA;EACE,kBAAA;AAMF;;AAJA;EACE,WAAA;AAOF;;AALA;EACE,UAAA;EACA,cAAA;EACA,aAAA;EACA,OAAA;AAQF;;AANA;EACE,aAAA;AASF;;AAPA;EACE,aAAA;AAUF;;AARA;EACE,cClCY;EDmCZ,kBAAA;EACA,eEtCU;EFuCV,gBAAA;EACA,iBAAA;AAWF;;AATA;EACE,cCzCY;ED0CZ,kBAAA;EACA,eE5CmB;EF6CnB,gBAAA;EACA,YAAA;AAYF;;AAVA;EACE,kBAAA;AAaF;;AAXA;EACE,kBAAA;AAcF;;AAXA;;;;;EAKE,aAAA;EACA,gBAAA;EACA,wCAAA;AAcF;;AAZA;;EAEE,eAAA;EACA,eAAA;AAeF;;AAZA;EACE,6BAAA;EACA,iBAAA;AAeF;;AAbA;EACE,6BAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;AAgBF;;AAdA;;EAEE,kBAAA;AAiBF;;AAdA;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,cAAA;AAiBF;;AAfA;EACE,eAAA;AAkBF;;AAhBA;EACE,eAAA;AAmBF;;AAjBA;EACE,eAAA;AAoBF;;AAlBA;EACE;IACE,WAAA;EAqBF;AACF;AAnBA;EACE,gCAAA;AAqBF;;AAlBA;EAEE,gCAAA;AAoBF;;AAjBA;EACE,gBAAA;EACA,eErHa;EFsHb,kBAAA;EACA,yBAAA;EACA,6BAAA;EACA,cC5Hc;ED6Hd,oBAAA;EACA,iBAAA;EACA,gCAAA;EACA,eAAA;AAoBF;;AAlBA;EACE,oCAAA;EACA,WChIa;ADqJf;;AAnBA;EACE,yBCtIgB;EDuIhB,qBCvIgB;EDwIhB,WCrIa;AD2Jf;;AApBA;EACE,uBAAA;EACA,gCAAA;AAuBF;;AArBA;EACE,aChJc;ADwKhB;;AAtBA;EACE,UC/Ia;ADwKf;;AAvBA;;EAEE,yBAAA;EACA,cAAA;EACA,eAAA;AA0BF;;AAxBA;EACE,eAAA;EACA,yBAAA;EACA,cAAA;EACA,sBAAA;AA2BF;;AAzBA;EACE,wBAAA;AA4BF;;AAzBA;EACE,qBAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cC7Kc;ED8Kd,gCAAA;EACA,eAAA;EACA,cAAA;EACA,oCAAA;EACA,iBAAA;EACA,oBAAA;AA4BF;;AAzBA;EACE,mBCvLc;EDwLd,WCpLa;ADgNf;;AAzBA;EACE,mBAAA;EACA,6DAAA;EACA,YAAA;AA4BF;;AAzBA;EACE,uBAAA;EACA,gCAAA;AA4BF;;AAzBA;EACE,aCvMc;ADmOhB;;AAzBA;EACE,UCvMa;ADmOf;;AAzBA;;EAEE,iCAAA;EACA,uCAAA;EACA,4BAAA;EACA,eAAA;AA4BF;;AAzBA;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AA4BF;;AAzBA;EACE,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,6BAAA;EACA,cAAA;EACA,oBAAA;EACA,gCAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;AA4BF;;AAzBA;EACE,UAAA;AA4BF;;AAzBA;EACE,aAAA;AA4BF;;AAzBA;EACE,aAAA;AA4BF;;AAzBA;EACE,WAAA;EACA,sBC1Pa;ED2Pb,UAAA;EACA,kBAAA;EACA,qBAAA;AA4BF;;AAzBA;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;AA4BF;;AAzBA;EACE,YAAA;EACA,WAAA;AA4BF;;AAzBA;EACE,eAAA;EACA,WAAA;EACA,sBC/Qa;EDgRb,UAAA;AA4BF;;AAzBA;EACE,6BAAA;EACA,MAAA;EACA,UAAA;EACA,WAAA;EACA,qCAAA;AA4BF;;AAzBA;EACE,kBAAA;EACA,MAAA;EACA,WAAA;EACA,UAAA;AA4BF;;AAzBA;EACE,cAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;AA4BF;;AAzBA;EACE,UAAA;AA4BF;;AAzBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AA4BF;;AA1BA;EACE,kBAAA;EACA,WAAA;AA6BF;;AA3BA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AA8BF;;AA5BA;EACE,aAAA;AA+BF;;AA7BA;EACE,aAAA;AAgCF;;AA9BA;EACE,gBAAA;AAiCF;;AA/BA;EACE,oBAAA;AAkCF;;AAhCA;EACE,kBAAA;AAmCF;;AAjCA;EACE,cAAA;EACA,qBAAA;EACA,YAAA;AAoCF;;AAlCA;EACE,cAAA;EACA,eAAA;EACA,wBAAA;EACA,mCAAA;EACA,gBAAA;AAqCF;;AAnCA;;EAEE,2BAAA;EACA,4BAAA;AAsCF;;AApCA;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;AAuCF;;AArCA;EACE,oBAAA;AAwCF;;AAtCA;EACE,cAAA;EACA,YAAA;EACA,sBAAA;EACA,sBAAA;EACA,6BAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,cAAA;AAyCF;;AAvCA;EACE,yBAAA;AA0CF;;AAxCA;EACE,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;EACA,uBAAA;AA2CF;;AAxCA;EACE,cAAA;AA2CF;;AAzCA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AA4CF;;AAxCA,WAAA;AACA;EACE,eAAA;EACA,oCAAA;EACA,aAAA;EACA,YAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,gBAAA;AA2CF;;AAxCA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EAEA,6CAAA;AA2CF;;AAxCA;EAEE,mBAAA;AA2CF;;AAxCA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,oBAAA;AA2CF;;AAxCA;EAEE,wBAAA;AA2CF;;AAzCA;EACE,kBAAA;AA4CF;;AA1CA,WAAA;AAgCA;EACE,mBCtdc;EDudd,8BAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;AAwCF;;AAtCA;EACE,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,YAAA;AAyCF;;AAtCA;EACE;IAEE,2BAAA;IAEA,oBAAA;EAyCF;EAtCA;IAEE,2BAAA;IAEA,yBAAA;EAwCF;EArCA;IAEE,0BAAA;IAEA,uBAAA;EAuCF;EApCA;IAEE,0BAAA;IAEA,yBAAA;EAsCF;AACF","sourcesContent":["@font-face {\n    font-family: \"Inter\";\n    src: local(\"Inter\"),\n     url(\"../assets/font/Inter-VariableFont.ttf\") format(\"truetype\");\n   }\n@mixin primeFont() {\n    font-family: \"Inter\";\n}","@import \"./mixins\";\n\n* {\n  @include primeFont();\n  margin: 0;\n  padding: 0;\n  text-decoration: none;\n  list-style: none;\n}\n.clearfix::after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\nhtml,\nbody {\n  font-size: 16px;\n}\nbody {\n  overflow-x: hidden;\n}\nsection {\n  width: 100%;\n}\n.row {\n  width: 96%;\n  margin: 0 auto;\n  display: flex;\n  gap: 2%;\n}\n.col-7 {\n  width: 58.33%;\n}\n.col-5 {\n  width: 41.66%;\n}\n.text {\n  color: $text_black;\n  text-align: center;\n  font-size: $textFont;\n  font-weight: 400;\n  line-height: 30px;\n}\n.subtext {\n  color: $text_black;\n  text-align: center;\n  font-size: $textFontSecondary;\n  font-weight: 500;\n  opacity: 50%;\n}\n.blurred {\n  filter: blur(10px);\n}\n.bg-blurred {\n  filter: blur(15px);\n}\n\n.my-input:focus,\n#country_code:focus,\nselect:focus,\n.profile-info-form input:focus,\n.profile-info-container select:focus {\n  outline: none;\n  box-shadow: none;\n  border: 1px solid #ee3a24cc;\n}\n.error,\n.MuiFormHelperText-root.Mui-error {\n  font-size: 11px;\n  margin: 0.25rem;\n  // color: #fff !important;\n}\n.error-bg-white {\n  color: #ee3a24cc;\n  font-size: 0.91vw;\n}\n.required-field {\n  color: #ee3a24cc;\n  font-weight: 400;\n  font-size: 0.902vw;\n  line-height: 1.25vw;\n  position: relative;\n  top: -0.25vw;\n}\ninput,\n.profile-info-container select {\n  border-radius: 6px;\n}\n\ninput::placeholder {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 14.52px;\n  color: #363636;\n}\nselect {\n  cursor: pointer;\n}\nselect:disabled {\n  cursor: default;\n}\n.stepper .round:not(:last-child) {\n  cursor: pointer;\n}\n@media (max-width: 768px) {\n  .col-5 {\n    width: 100%;\n  }\n}\n.Mui-focused .MuiOutlinedInput-notchedOutline {\n  border-color: #ee3a24 !important;\n}\n\n.MuiInputBase-root.MuiInputBase-formControl:hover\n  .MuiOutlinedInput-notchedOutline {\n  border-color: #ee3a24 !important;\n}\n\n.button {\n  font-weight: 600;\n  font-size: $buttonFonts;\n  border-radius: 4px;\n  border: 1px solid $primary-color;\n  background-color: transparent;\n  color: $primary-color;\n  line-height: 16.94px;\n  padding: 5px 24px;\n  transition: 0.2s ease-in-out all;\n  cursor: pointer;\n}\n.button:not([disabled]):hover {\n  background-color: $primary-color!important;\n  color: $color_white;\n}\n.button:not([disabled]):active {\n  background-color: $secondary-color;\n  border-color: $secondary-color;\n  color: $color_white;\n}\n.button svg {\n  background: transparent;\n  transition: 0.2s ease-in-out all;\n}\n.button svg path {\n  fill: $primary-color;\n}\n.button:hover svg path {\n  fill: $color_white;\n}\nbutton:disabled,\nbutton[disabled] {\n  border: 1px solid #808080;\n  color: #808080;\n  cursor: default;\n}\nbutton:disabled {\n  cursor: default;\n  border: 1px solid #ee3a24;\n  color: #ee3a24;\n  background-color: #fff;\n}\nbutton:disabled svg path {\n  fill: #ee3a24 !important;\n}\n\n.button2 {\n  font-size: 1.040625vw;\n  font-weight: 600;\n  line-height: 1.665vw;\n  letter-spacing: 0em;\n  text-align: center;\n  border-radius: 0.555vw;\n  border: 1px solid #ffffff;\n  color: $primary-color;\n  transition: 0.2s ease-in-out all;\n  cursor: pointer;\n  color: #ffffff;\n  background: #ffffff33;\n  height: 3.12243vw;\n  min-width: 12.4875vw;\n}\n\n.button2:not([disabled]):hover {\n  background: $primary-color;\n  color: $color_white;\n}\n\n.button2:not([disabled]):active {\n  background: #ca311e;\n  box-shadow: 0px 4px 4px 0px #00000040 inset;\n  border: none;\n}\n\n.button2 svg {\n  background: transparent;\n  transition: 0.2s ease-in-out all;\n}\n\n.button2 svg path {\n  fill: $primary-color;\n}\n\n.button2:hover svg path {\n  fill: $color_white;\n}\n\n.button2:disabled,\n.button2[disabled] {\n  background: #4d4d4d33;\n  border: 1px solid #4d4d4d33;\n  color: #2e2e2e99;\n  cursor: default;\n}\n\nnav .custom-create-title {\n  width: 100%;\n  flex-basis: 100%;\n  font-family: Inter;\n  font-size: 1.125rem;\n  font-weight: 700;\n  line-height: 22px;\n  letter-spacing: 0em;\n  text-align: center;\n  color: #ee3a24;\n}\n\n.play-icon-button {\n  font-weight: 600;\n  font-size: 14px;\n  border-radius: 4px;\n  border: 1px solid #ee3a24;\n  background-color: transparent;\n  color: #ee3a24;\n  line-height: 16.94px;\n  transition: 0.2s ease-in-out all;\n  cursor: pointer;\n  padding: 0px;\n  border: none;\n}\n\n.play-icon-button svg {\n  width: 80%;\n}\n\n.play-icon-button:hover svg path {\n  stroke: white;\n}\n\n.play-icon-button:hover svg {\n  fill: #ee3a24;\n}\n\n.header {\n  width: 100%;\n  background-color: $color_white;\n  z-index: 2;\n  position: relative;\n  min-height: 3.81618vw;\n}\n\n.nav-list li .dropdown-menu > a {\n  display: flex;\n  height: 100%;\n  align-items: center;\n  justify-content: center;\n}\n\n.settings select {\n  border: none;\n  width: 20px;\n}\n\n.dashboard-header {\n  position: fixed;\n  width: 100%;\n  background-color: $color_white;\n  z-index: 2;\n}\n\n.header-absolute {\n  position: absolute !important;\n  top: 0;\n  z-index: 2;\n  width: 100%;\n  background: rgba(256, 256, 256, 0.55);\n}\n\n.header-absolute2 {\n  position: absolute;\n  top: 0;\n  width: 100%;\n  z-index: 2;\n}\n\nnav {\n  max-width: 96%;\n  width: 100%;\n  margin: 0 auto;\n  padding: 0.49vw 0;\n}\n\nnav img {\n  width: 80%;\n}\n\nul {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.header nav ul li {\n  position: relative;\n  top: 0.42vw;\n}\n.header-content {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.user-image {\n  display: flex;\n}\n.nav-list {\n  display: flex;\n}\n.nav-list {\n  list-style: none;\n}\n.nav-list li:nth-child(1) {\n  margin-right: 1.65vw;\n}\n.nav-list li {\n  position: relative;\n}\n.nav-list li a {\n  display: block;\n  text-decoration: none;\n  color: black;\n}\n.user-image img {\n  width: 2.775vw;\n  height: 2.775vw;\n  border-radius: 0.20868vw;\n  box-shadow: 0 0 0.20868vw gainsboro;\n  margin: 0.2775vw;\n}\n.user-image .sb-avatar,\n.user-image .sb-avatar__text {\n  width: 2.15118vw !important;\n  height: 2.15118vw !important;\n}\n.dropdown {\n  width: 100%;\n  position: absolute;\n  z-index: 999;\n  display: none;\n}\n.dropdown-menu {\n  margin: 0.4vw 0.25vw;\n}\n.show {\n  width: 16.65vw;\n  height: auto;\n  padding: 1.39vw 1.11vw;\n  background-color: #fff;\n  box-shadow: 0 0 3px gainsboro;\n  border-radius: 3px;\n  position: absolute;\n  top: 3.01vw;\n  right: -1.11vw;\n  z-index: 999;\n  display: block;\n}\n.show li {\n  padding: 0.555vw 0.8325vw;\n}\n.user-email {\n  white-space: nowrap;\n  width: 100%;\n  overflow: hidden;\n  display: block;\n  color: #ababab;\n  text-overflow: ellipsis;\n}\n\n.dropdown li {\n  display: block;\n}\n.flex-list-item {\n  display: flex;\n  gap: 25px;\n  align-items: center;\n}\n\n//   LOADER COMPONENT\n/* Loader */\n.mesh-loader {\n  position: fixed;\n  background-color: rgb(0, 0, 0, 0.2);\n  height: 100vh;\n  width: 100vw;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 9999999;\n}\n\n.mesh-loader .circle {\n  width: 25px;\n  height: 25px;\n  position: fixed;\n  background: #2962ff;\n  border-radius: 50%;\n  margin: -12.5px;\n  -webkit-animation: mesh 3s ease-in-out infinite;\n  animation: mesh 3s ease-in-out infinite -1.5s;\n}\n\n.mesh-loader > div .circle:last-child {\n  -webkit-animation-delay: 0s;\n  animation-delay: 0s;\n}\n\n.mesh-loader > div {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  z-index: 99999999999;\n}\n\n.mesh-loader > div:last-child {\n  -webkit-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n.blurred-background {\n  filter: blur(10px);\n}\n/* Loader */\n\n@-webkit-keyframes mesh {\n  0% {\n    -webkit-transform-origin: 50% -100%;\n    transform-origin: 50% -100%;\n    -webkit-transform: rotate(0);\n    transform: rotate(0);\n  }\n\n  50% {\n    -webkit-transform-origin: 50% -100%;\n    transform-origin: 50% -100%;\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n\n  50.00001% {\n    -webkit-transform-origin: 50% 200%;\n    transform-origin: 50% 200%;\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n\n  100% {\n    -webkit-transform-origin: 50% 200%;\n    transform-origin: 50% 200%;\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n.theme-backdrop:after {\n  background: $primary-color;\n  filter: blur(154.14999389648438px);\n  top: -25.69px;\n  left: -51px;\n  z-index: -1;\n}\n.theme-backdrop:before {\n  background: #9747ff;\n  filter: blur(154.14999389648438px);\n  bottom: 0px;\n  right: -51px;\n}\n\n@keyframes mesh {\n  0% {\n    -webkit-transform-origin: 50% -100%;\n    transform-origin: 50% -100%;\n    -webkit-transform: rotate(0);\n    transform: rotate(0);\n  }\n\n  50% {\n    -webkit-transform-origin: 50% -100%;\n    transform-origin: 50% -100%;\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n\n  50.00001% {\n    -webkit-transform-origin: 50% 200%;\n    transform-origin: 50% 200%;\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n\n  100% {\n    -webkit-transform-origin: 50% 200%;\n    transform-origin: 50% 200%;\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n","$primary-color: #EE3A24;\n$secondary-color: #923D32;\n\n$text_black : #000000;\n$color_white : #fff;\n","$headingFont :45px;\n$textFont : 22px;\n$textFontSecondary : 10px;\n$buttonFonts : 14px;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
